import { ChannelType } from '@core/websockets/echo.model';
import { ProfileStateModel } from '@data/profile/profile.actions';
import { ToastNotificationService } from '@shared/services/toast-notification.service';
import { EchoService } from '@core/websockets/echo.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OrderEventsService {
  constructor(
    private echoService: EchoService,
    private toastNotificationService: ToastNotificationService,
  ) {}

  listenForOrderStatus(user: ProfileStateModel): void {
    const userId = user.id;

    if (!userId) {
      console.warn('User ID is missing. Cannot listen for order status updates.');

      return;
    }

    this.echoService.listen(
      {
        channel: {
          type: ChannelType.PRIVATE,
          name: `notifications.${userId}`,
        },
        event: 'general.notification',
      },
      (notification: Notification) => {
        const message = notification.data.message;

        if (!message) {
          console.warn('Received notification without a message:', notification);

          return;
        }

        switch (notification.data.type) {
          case 'error':
            this.toastNotificationService.showError(message);
            break;
          case 'warning':
            this.toastNotificationService.showWarning(message);
            break;
          case 'success':
            this.toastNotificationService.showSuccess(message);
            break;
          case 'info':
            this.toastNotificationService.showInfo(message);
            break;
          default:
            console.warn('Unknown notification type:', notification.data.type);
        }
      },
    );
  }
}
